function PaymentItemService(BBModel, UnwrapService) {
    'ngInject';

    return {
        unwrap(resource) {
            return UnwrapService.unwrapResource(BBModel.Member.PaymentItem, resource);
        }
    };
}

angular
    .module('BBMember')
    .service('BB.Service.payment_item', PaymentItemService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/member/_services/service_payment_item.service.js